import { Box } from "@mui/material";
import { FC } from "react";
import HighlightPlayer from "../../../Components/VideoPlayer";
import GameListTable from "./GameListTable";

const GameList: FC = () => {
  return (
    <Box>
      <GameListTable />
    </Box>
  );
};

export default GameList;
